import { useUser } from "@spt/bezel/src/Providers/UserProvider";
import { PropsWithChildren, ReactElement } from "react";

type AdminAccessProps = {
    DeniedMessage?: ReactElement;
    SiteAdmins: Array<String> | undefined
};

export function AdminAccess(
    props: PropsWithChildren<AdminAccessProps>,
): ReactElement {
    const _users = useUser();

    const SADs = props.SiteAdmins ?? [];

    const minim = _users?.Min ?? false;

    const AuthedUser = _users?.AuthedUser;
    const ViewAsUser = _users?.ViewAsUser;

    const AUName = AuthedUser?.userPrincipalName.replace("@essex.ac.uk", "");
    const VAName = ViewAsUser?.userPrincipalName.replace("@essex.ac.uk", "");

    if (minim) {
        const checkname = (VAName || AUName) ?? "";
        if (SADs.includes(checkname)) {
            return <>{props.children}</>;
        } else {
            return props.DeniedMessage || <></>;
        }
    } else {
        if (SADs.includes(AUName ?? "") || SADs.includes(VAName ?? "")) {
            return <>{props.children}</>;
        } else {
            return props.DeniedMessage || <></>;
        }
    }

}
